/**
 * Registers the notes-domain UI intents (notes.openNote). Idempotent — called
 * once at app startup. Owns the `notes.*` namespace (domain ownership).
 */
import { registerIntent } from '@features/agentUi/uiIntentDispatcher';
import { DOC_PARAM } from '@features/study/utils/buildDocumentUrl';

let registered = false;

/** Register notes.* intent handlers once. */
export function registerNotesIntents(): void {
  if (registered) return;
  registered = true;

  registerIntent('notes.openNote', (args, ctx) => {
    const documentId = args.document_id;
    if (typeof documentId !== 'string' || !documentId) return; // fail-closed
    // The editor opens a document by id via the shared `?doc=` deep link; a
    // path would select nothing there.
    ctx.navigate(`/notes/editor?${DOC_PARAM}=${encodeURIComponent(documentId)}`);
  });
}

/** Test-only: allow re-registration after a dispatcher reset. */
export function __resetNotesIntentRegistrationForTests(): void {
  registered = false;
}
